module.exports = __webpack_public_path__ + "895c99652aa74c25c537af4919e90b84.MP3";